import React from 'react';

import { ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';
import { Messages } from '~src/codegen/Localize';
import { EditClusterNameField } from '~src/settings/dataconnect-settings/sections/dataConnectMultiCluster/EditClusterNameField';

export type PropsForEditDataConnectClusterDialog = ReactActionDialogBodyProps<
  EditDataConnectClusterDialogProps,
  EditDataConnectClusterDialogState
>;

export type EditDataConnectClusterDialogProps = Readonly<{
  existingClusterNames: string[];
}>

export type EditDataConnectClusterDialogState = Readonly<{
  clusterName: string;
  hasError: boolean;
}>

export function EditDataConnectClusterDialogBody(props: PropsForEditDataConnectClusterDialog) {
  const onPoolNameChange = (clusterName: string) => {
    props.updateDialogState({ clusterName });
  };
  const onHasErrorChange = (hasError: boolean) => {
    props.updateDialogState({ hasError });
  };

  return (
    <EditClusterNameField
      clusterName={props.dialogState.clusterName}
      onClusterNameChange={onPoolNameChange}
      hasError={props.dialogState.hasError}
      onHasErrorChange={onHasErrorChange}
      existingClusterNames={props.existingClusterNames}
      description={Messages.dataConnectSiteSettingsEditClusterDialogDescription()}
    />
  );
}
